const TOKEN_KEY = 'm3-dataadmin-token'

export function getToken() {
  let token = localStorage.getItem(TOKEN_KEY)
  if (!token) {
    token = ''
  }
  return token
}
export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token)
  console.log(TOKEN_KEY, token, '设置token')
}
